import axios from 'axios';
import {
  ABOUT_TITLE_API_URL,
  MEMBERS_TITLE_API_URL,
  VOTES_TITLE_API_URL,
  DOCUMENTS_TITLE_API_URL,
  NEWS_TITLE_API_URL,
  PARTNERS_TITLE_API_URL,
  LIVE_TITLE_API_URL,
} from '../../constants/urls';

const state = {
    aboutTitle: null,
    membersTitle: null,
    votesTitle: null,
    documentsTitle: null,
    partnersTitle: null,
    newsTitle: null,
    liveTitle: null,
};

const actions = {
    getAboutTitle({ commit }) {
        const host = this.state.context.host;

        axios.get( host + ABOUT_TITLE_API_URL, { withCredentials: true } )
            .then((result) => {
                commit('aboutTitle', result.data.content);
            })
            .catch((error) => {
                /* eslint-disable no-console */
                console.log(error);
            });
    },

    getMembersTitle({ commit }) {
        const host = this.state.context.host;

        axios.get( host + MEMBERS_TITLE_API_URL, { withCredentials: true })
            .then((result) => {
                commit('membersTitle', result.data.content);
        })
        .catch((error) => {
            /* eslint-disable no-console */
            console.log(error);
        });
    },

    getVotesTitle({ commit }) {
        const host = this.state.context.host;

        axios.get( host + VOTES_TITLE_API_URL, { withCredentials: true })
            .then((result) => {
                commit('votesTitle', result.data.content);
        })
        .catch((error) => {
            /* eslint-disable no-console */
            console.log(error);
        });
    },

    getDocumentsTitle({ commit }) {
      const host = this.state.context.host;

      axios.get(host + DOCUMENTS_TITLE_API_URL, { withCredentials: true } )
      .then((result) => {
          commit('documentsTitle', result.data.content);
      })
      .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
      });
    },

    getPartnersTitle({ commit }) {
      const host = this.state.context.host;

      axios.get(host + PARTNERS_TITLE_API_URL, { withCredentials: true } )
      .then((result) => {
          commit('partnersTitle', result.data.content);
      })
      .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
      });
    },

    getNewsTitle({ commit }) {
      const host = this.state.context.host;

      axios.get(host + NEWS_TITLE_API_URL, { withCredentials: true } )
      .then((result) => {
          commit('newsTitle', result.data.content);
      })
      .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
      });
    },

    getLiveTitle({ commit }) {
      const host = this.state.context.host;

      axios.get(host + LIVE_TITLE_API_URL, { withCredentials: true } )
      .then((result) => {
          commit('liveTitle', result.data.content);
      })
      .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
      });
    }
};

const mutations = {
    aboutTitle(state, value) {
        state.aboutTitle = value;
    },

    membersTitle(state, value) {
        state.membersTitle = value;
    },

    votesTitle(state, value) {
        state.votesTitle = value;
    },

    documentsTitle(state, value) {
      state.documentsTitle = value;
    },

    partnersTitle(state, value) {
      state.partnersTitle = value;
    },

    newsTitle(state, value) {
      state.newsTitle = value;
    },

    liveTitle(state, value) {
      state.liveTitle = value
    }
};

const getters = {
    aboutTitle({ aboutTitle }) {
        return aboutTitle;
    },

    membersTitle({ membersTitle }) {
        return membersTitle;
    },

    votesTitle({ votesTitle }) {
        return votesTitle;
    },

    documentsTitle ({ documentsTitle }) {
      return documentsTitle;
    },

    partnersTitle ({ partnersTitle }) {
      return partnersTitle;
    },

    newsTitle ({ newsTitle }) {
      return newsTitle;
    },

    liveTitle ({ liveTitle }) {
      return liveTitle;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/titles.js